import * as React from 'react'

import Paper from '@mui/material/Paper'
import { useSelector } from 'react-redux'

import { NoteContent } from './NoteContent'
import { selectAllEntityFormSettings } from '@user/store/entityFormSettings'
import { addLeadNote } from '@user/components/Settings/EntityFormSettings/constants'
import { useGetFieldActiveStates } from '@user/store/entityFormSettings/hooks/useGetFieldActiveStates'
import { NoteCode } from '@user/components/Notes/typings'

type Props = {
  hideOptional: boolean
  variant: 'card' | 'standard'
  noteCodes: NoteCode[]
  hideTitle?: boolean
}

export function Note(props: Props) {
  const { hideOptional, variant, noteCodes, hideTitle } = props

  const settings = useSelector(selectAllEntityFormSettings)
  const entitySettingsMap = useGetFieldActiveStates(settings, hideOptional)

  const [requiredAddNote, showAddNote] = entitySettingsMap.get(addLeadNote) ?? [
    false,
    true,
  ]

  return showAddNote ? (
    variant === 'card' ? (
      <Paper variant="outlined" sx={{ py: 2, px: 3 }}>
        <NoteContent
          required={requiredAddNote}
          noteCodes={noteCodes}
          hideTitle={!!hideTitle}
        />
      </Paper>
    ) : (
      <NoteContent
        required={requiredAddNote}
        noteCodes={noteCodes}
        hideTitle={!!hideTitle}
      />
    )
  ) : null
}
